import LanguageService from "../../../services/Language.service";
import {getStatusStyle} from "../../../utils/style";
import {
    AVAILABLE_UNTIL,
    CURRENCY,
    EARLY_TRADING_PERIOD,
    FUND_CODE,
    INVESTOR_SUMMARY,
    NOTE_NAME,
    PROTECTION,
    RETURN_DESCRIPTION,
    SALES_COMMISSION,
    STATUS_NAME,
    TERM,
    UNDERLIER,
} from "../constants/NewCurrentOfferings";
import React from "react";

export const columnDefinition = [
    {
        header: "Note Name",
        key: "noteName",
        languageCode: NOTE_NAME,
        render: (value, row, currentLanguage) => (
            <div>
                <span>{value}</span>
                {row.investorSummaryExists && row.code && (
                    <div>
                        <a
                            target="_blank"
                            rel="noreferrer"
                            href={`/detail/${
                                row.code
                            }/file/investor_summary/${currentLanguage.toUpperCase()}`}
                        >
                            {LanguageService.translate(INVESTOR_SUMMARY)}
                        </a>
                    </div>
                )}
            </div>
        ),
    },
    {
        header: "Fund_Code_W360",
        key: "fundCode",
        languageCode: FUND_CODE,
        className: "centered",
        render: (value, row) => (
            <div>
                <a target="_blank" rel="noreferrer" href={`/detail/${row.code}`}>
                    {value}
                </a>
                <div>{row.w360}</div>
            </div>
        ),
    },
    {
        header: "Return Description",
        key: "returnDescription",
        languageCode: RETURN_DESCRIPTION,
        className: "return-description",
        render: (value, row) => (
            <div>
                {row.returnDescription
                    .split(";")
                    .map((item, i) => (
                        <div key={i}>{item}</div>
                    ))}
            </div>
        ),
    },
    {header: "Protection", key: "protection", languageCode: PROTECTION, className: "centered"},
    {header: "Underlier", key: "underlier", languageCode: UNDERLIER, className: "centered"},
    {header: "Term", key: "term", languageCode: TERM, className: "centered"},
    {
        header: "Available Until",
        key: "availableUntil",
        languageCode: AVAILABLE_UNTIL,
        className: "centered"
    },
    {
        header: "Early Trading Period",
        key: "earlyTradingPeriod",
        languageCode: EARLY_TRADING_PERIOD,
        className: "centered"
    },
    {header: "CCY", key: "currency", languageCode: CURRENCY, className: "centered"},
    {
        header: "Sales Commission",
        key: "salesCommission",
        languageCode: SALES_COMMISSION,
        className: "centered",
        render: (value, row) => (
            <div>
                <div>{value}</div>
                <div>{row.productClass}</div>
            </div>
        ),
    },
    {
        header: "Status", key: "statusName", languageCode: STATUS_NAME,
        className: "centered",
        render: (value, rowData) => (
            <div>
                <span className={getStatusStyle(rowData.status)}>{value}</span>
            </div>
        ),

    },
];
